import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getFunctions, Functions } from 'firebase/functions';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { logger } from '@/shared/utils/logger';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;
let functions: Functions | null = null;
let storage: FirebaseStorage | null = null;

export const initFirebase = (): void => {
  if (!app) {
    // Vérifier que les variables d'environnement sont définies
    if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
      logger.warn(
        'Firebase n\'est pas configuré. Veuillez définir les variables d\'environnement dans .env'
      );
      return;
    }
    try {
      app = initializeApp(firebaseConfig);
      auth = getAuth(app);
      db = getFirestore(app);
      // Région des Cloud Functions
      functions = getFunctions(app, 'europe-west1');
      storage = getStorage(app);
    } catch (error) {
      logger.error('Erreur lors de l\'initialisation de Firebase:', error);
    }
  }
};

export const getFirebaseAuth = (): Auth | null => {
  if (!auth) {
    initFirebase();
  }
  return auth;
};

export const getFirebaseDb = (): Firestore | null => {
  if (!db) {
    initFirebase();
  }
  return db;
};

export const getFirebaseFunctions = (): Functions | null => {
  if (!functions) {
    initFirebase();
  }
  return functions;
};

export const getFirebaseStorage = (): FirebaseStorage | null => {
  if (!storage) {
    initFirebase();
  }
  return storage;
};

